import { render, staticRenderFns } from "./MobileAdminLayout.vue?vue&type=template&id=54c73b50&scoped=true"
import script from "./MobileAdminLayout.vue?vue&type=script&lang=js"
export * from "./MobileAdminLayout.vue?vue&type=script&lang=js"
import style0 from "./MobileAdminLayout.vue?vue&type=style&index=0&id=54c73b50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c73b50",
  null
  
)

export default component.exports